import api from './client';

// Phase 50 — Social actions on posts (hide, report, share, favorites, public detail).

// Anonymous session id fallback used when the user is not logged in.
// Reuses the same key created by the support chat for consistency.
const ANON_KEY = 'nymia_anon_session_id';
export const getAnonSessionId = () => {
  if (typeof window === 'undefined') return '';
  let id = window.localStorage.getItem(ANON_KEY);
  if (!id) {
    id = `anon_${Math.random().toString(36).slice(2, 10)}_${Date.now().toString(36)}`;
    try { window.localStorage.setItem(ANON_KEY, id); } catch { /* private mode */ }
  }
  return id;
};

// ---- Hide / Non mostrare più ----
export const hidePost = async (postId) => {
  const params = {};
  if (!localStorage.getItem('ig_token')) params.session_id = getAnonSessionId();
  const res = await api.post(`/posts/${postId}/hide`, null, { params });
  return res.data;
};

export const unhidePost = async (postId) => {
  const params = {};
  if (!localStorage.getItem('ig_token')) params.session_id = getAnonSessionId();
  const res = await api.delete(`/posts/${postId}/hide`, { params });
  return res.data;
};

export const listHiddenIds = async () => {
  const params = {};
  if (!localStorage.getItem('ig_token')) params.session_id = getAnonSessionId();
  const res = await api.get('/posts/hidden/ids', { params });
  return res.data.hidden_post_ids || [];
};

// ---- Report ----
export const reportPost = async (postId, { reason, notes = '' }) => {
  const res = await api.post(`/posts/${postId}/report`, { reason, notes });
  return res.data;
};

// Phase F4 — report a USER from the chat (reuses the reports system).
export const reportUser = async (username, { reason, notes = '' }) => {
  const res = await api.post(`/users/${encodeURIComponent(username)}/report`, { reason, notes });
  return res.data;
};

// ---- Public detail (works anonymous) ----
export const fetchPublicPost = async (postId) => {
  const res = await api.get(`/posts/${postId}/public`);
  return res.data;
};

// ---- Internal share ----
export const sharePostInternal = async (postId, { to_username, note = '' }) => {
  const res = await api.post(`/posts/${postId}/share/internal`, { to_username, note });
  return res.data;
};

// ---- Admin reports ----
export const adminListReports = async (status) => {
  const res = await api.get('/admin/reports', { params: status ? { status } : {} });
  return res.data;
};

export const adminReportCounts = async () => {
  const res = await api.get('/admin/reports/counts');
  return res.data;
};

export const adminUpdateReportStatus = async (reportId, status, actionTaken) => {
  const payload = {};
  if (status) payload.status = status;
  if (actionTaken !== undefined && actionTaken !== null) payload.action_taken = actionTaken;
  const res = await api.patch(`/admin/reports/${reportId}`, payload);
  return res.data;
};

// ---- Public share link builder ----
// Phase 50.1 — Share URL now points at the backend OG preview endpoint so
// WhatsApp/Telegram/Slack/Facebook crawlers scrape rich meta tags. Users
// get transparently redirected to `/post/:postId` on click.
export const buildPostShareUrl = (postId) => {
  if (!postId) return '';
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}/api/og/post/${postId}`;
};
